import axios from 'axios'

const SCHEDULE_PATH = '/foodcourt/schedule'

const state = {
  days: null
}

const getters = {
  getDays: state => state.days
}

const mutations = {
  SET_SCHEDULE (state, result) {
    state.days = result.days
  }
}

const actions = {
  async GET_SCHEDULE ({ commit }) {
    const { data } = await axios.get(SCHEDULE_PATH)
    commit('SET_SCHEDULE', data.payload.result)
  }
}

export default { namespaced: true, state, getters, mutations, actions }
